import { type GasPayload } from '@atlaskit/analytics-gas-types';

export const onAllSuggestedQueriesShown = ({
	actionSubjectId,
	attributes,
	nonPrivacySafeAttributes,
}: {
	actionSubjectId: string;
	attributes: Record<string, any>;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	source: 'searchDialog',
	eventType: 'ui',
	action: 'shown',
	actionSubject: 'suggestedQueries',
	actionSubjectId,
	attributes,
	nonPrivacySafeAttributes,
});
